import { z } from 'zod';
import { entityMetaSchema } from '../../utils';

export const gridBaseSchema = z.object({
    id: z.string(),
    parentId: z.string(),
    children: z.array(z.array(z.unknown())),
    entityType: z.literal('grid'),
    version: z.number().int().nonnegative(),
    meta: entityMetaSchema,
});
